import { useI18n } from "@/i18n/I18nProvider";
import { colors } from "../../utils/const";
import dynamic from "next/dynamic";
import Box from "@mui/material/Box";

const SmallTitle = dynamic(
  () => import("@/components/mini-components/SmallTitle"),
);

export default function Financing_Insurance_Products() {
  const { t, locale } = useI18n();

  return (
    <Box
      id="Financing_Insurance_Products"
      data-section="Financing_Insurance_Products"
      sx={{
        backgroundColor: "white",
      }}
    >
      {" "}
      <Box
        className="horizontal-safe-padding "
        sx={{
          backgroundColor: colors.baby_white,
          borderRadius: "24px  24px 0px 0px",
          display: "flex",
          flexDirection: "column",
          gap: { xs: "50px", md: "80px" },
          paddingTop: { xs: "40px", md: "80px" },
          paddingBottom: { xs: "40px", md: "80px" },
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "650px" },
            margin: "0 auto",
          }}
        >
          <SmallTitle
            title={
              t.pages_main_tags.whyContact.financingInsuranceProducts.title
            }
            type="why-contact"
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: "20px", md: "80px" },
          }}
        >
          {t.pages_main_tags.whyContact.financingInsuranceProducts.products.map(
            (product, index) => (
              <Box
                key={product.id}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: { xs: "start", xl: "center" },
                  gap: { xs: "24px", md: "48px" },
                  borderRadius: "24px",
                  padding: { xs: "20px", md: "40px" },
                  background: "white",
                  boxShadow: " 0px 6px 40px 0px rgba(0, 0, 0, 0.06)",
                  position: { xs: "", md: "sticky" },
                  top: { xs: "", md: "100px", lg: "180px" },
                }}
              >
                {/* Product Image */}
                <Box
                  sx={{
                    flex: { xs: "1 1 100%", md: "1 1 50%", lg: "1 1 33%" },
                    height: {
                      xs: "400px",
                      md: "350px",
                      lg: "300px",
                      xl: "450px",
                    },
                    display: "flex",
                    width: "100%",
                  }}
                >
                  {t.pages_main_tags.whyContact.financingInsuranceProducts
                    .products.length -
                    1 ===
                  index ? (
                    <Box
                      sx={{
                        width: "100%",
                        height: {
                          xs: "350px",
                          md: "350px",
                          lg: "300px",
                          xl: "450px",
                        },
                        backgroundColor: colors.orange,
                        borderRadius: "24px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        component="img"
                        loading="lazy"
                        src={t.general.gifs.hi}
                        alt="my gif"
                        sx={{
                          width: { xs: "150px", sm: "200px", md: "250px" },
                          height: { xs: "150px", sm: "200px", md: "250px" },
                        }}
                      />

                      {/* <Box
                        component="video"
                        src={t.general.gifs.hi}
                        autoPlay
                        loop
                        muted
                        playsInline
                        sx={{
                          width: { xs: "150px", sm: "200px", md: "250px" },
                          height: { xs: "150px", sm: "200px", md: "250px" },
                          objectFit: "contain",
                        }}
                      /> */}
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <Box
                        component="img"
                        alt={product.title}
                        src={product.img}
                        sx={{
                          width: "100%",
                          height: "100%",
                          flexShrink: 0,
                        }}
                      />
                    </Box>
                  )}
                </Box>
                {/* Product Details */}

                <Box
                  sx={{
                    flex: { xs: "1 1 100%", md: "1 1 67%" },
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    gap: { xs: "20px", md: "30px" },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      justifyContent: "center",
                      gap: { xs: "20px", md: "30px" },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "",
                        gap: "16px",
                        maxWidth: "600px",
                      }}
                    >
                      <Box
                        component="a"
                        href={product.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          color: colors.orange,
                          fontSize: {
                            xs: "13px",
                            sm: "16px",
                            md: "18px",
                            lg: "20px",
                          },
                          fontWeight: "600",
                          borderRadius: "24px",
                          border: `1px solid ${colors.orange}`,
                          padding: { xs: "10px", md: "16px" },
                          width: "fit-content",
                          display: "inline-block",
                          textDecoration: "none",
                        }}
                      >
                        {product.title}
                      </Box>
                      <Box
                        sx={{
                          color: colors.dark_black,
                          fontSize: {
                            xs: "14px",
                            md: "16px",
                            lg: "18px",
                          },
                          fontWeight: "400",
                          lineHeight: "1.6",
                        }}
                      >
                        {product.text}
                      </Box>
                    </Box>

                    {/* Services within Each Product */}
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: {
                          xs: "12px",
                          md: "8px",
                        },
                      }}
                    >
                      {product.services.map((service) => (
                        <Box
                          key={service.id}
                          sx={{
                            backgroundColor: colors.light_baby_white,
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                            borderRadius: "8px",
                            padding: "8px 12px",
                            flex: {
                              xs: "1 1 calc(50% - 12px)",
                              lg: "1 1 calc(25% - 12px)",
                            },
                            height: { md: "180px", lg: "230px" },
                          }}
                        >
                          {/* Service Image */}
                          <Box
                            component="img"
                            alt={service.text}
                            src={service.img}
                            sx={{
                              width: "50px",
                              height: "50px",
                              objectFit: "contain",
                            }}
                          />

                          <Box
                            sx={{
                              color: colors.c_dark_grey,
                              fontSize: "14px",
                              lineHeight: " 1.7",
                            }}
                          >
                            {service.text}
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Box>
              </Box>
            ),
          )}
        </Box>
      </Box>
    </Box>
  );
}
